import _regeneratorRuntime from "@babel/runtime/regenerator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @file Highway core that handle all history stuffs.
 * @author Anthony Du Pont <bulldog@dogstudio.co>
 */
import Emitter from 'tiny-emitter';
import Helpers from './helpers';

var Core =
/*#__PURE__*/
function (_Emitter) {
  _inherits(Core, _Emitter);

  /**
   * @arg {object} opts — User options
   * @arg {object} opts.renderers — List of renderers
   * @arg {object} opts.transitions — List of transitions
   * @extends Emitter
   * @constructor
   */
  function Core() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        renderers = _ref.renderers,
        transitions = _ref.transitions;

    _classCallCheck(this, Core);

    // Extends the Emitter constructor in order to be able to use its features
    // and send custom events all along the script.
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Core).call(this)); // Helpers.

    _this.Helpers = new Helpers(renderers, transitions); // Prep contextual transition info.

    _this.Transitions = transitions;
    _this.Contextual = false; // Properties & state.

    _this.location = _this.Helpers.getLocation(window.location.href);
    _this.properties = _this.Helpers.getProperties(document.cloneNode(true)); // Status variables.

    _this.popping = false;
    _this.running = false; // Trigger Element

    _this.trigger = null; // Cache

    _this.cache = new Map();

    _this.cache.set(_this.location.href, _this.properties); // Get the page renderer and properly setup it.


    _this.properties.renderer.then(function (Renderer) {
      _this.From = new Renderer(_this.properties);

      _this.From.setup();
    }); // Events variables.


    _this._navigate = _this.navigate.bind(_assertThisInitialized(_this)); // Listen the `popstate` on the window to run the router each time an
    // history entry changes. Basically everytime the backward/forward arrows
    // are triggered by the user.

    window.addEventListener('popstate', _this.popState.bind(_assertThisInitialized(_this))); // Get all elligible links.

    _this.links = document.querySelectorAll('a:not([target]):not([data-router-disabled])'); // Event attachement

    _this.attach(_this.links);

    return _this;
  }
  /**
   * Attach `click` event on links.
   *
   * @param {(array|nodeList)} links - Links to use
   */


  _createClass(Core, [{
    key: "attach",
    value: function attach(links) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var link = _step.value;
          link.addEventListener('click', this._navigate);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    /**
     * Detach `click` event on links.
     *
     * @param {(array|nodeList)} links - Links to use
     */

  }, {
    key: "detach",
    value: function detach(links) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = links[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var link = _step2.value;
          link.removeEventListener('click', this._navigate);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
    /**
     * Click method called on `click` event.
     *
     * @arg {object} e - `click` event
     */

  }, {
    key: "navigate",
    value: function navigate(e) {
      if (!(e.metaKey || e.ctrlKey)) {
        // Prevent default `click`
        e.preventDefault(); // Check to see if this navigation will use a contextual transition

        var contextual = e.currentTarget.hasAttribute('data-transition') ? e.currentTarget.dataset.transition : false; // We have to redirect to our `href` using Highway
        // There we set up the contextual transition, so this and Core.redirect can pass in either transition name or false

        this.redirect(e.currentTarget.href, contextual, e.currentTarget);
      }
    }
    /**
     * Redirect to URL
     *
     * @param {string} href - URL
     * @param {(object|boolean)} contextual - If the transition is changing on the fly
     * @param {(object|string)} trigger - The trigger element or a string
     */

  }, {
    key: "redirect",
    value: function redirect(href) {
      var contextual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'script';
      // Save Trigger Element
      this.trigger = trigger; // When our URL is different from the current location `href` and no other
      // navigation is running for the moment we are allowed to start a new one.
      // But if the URL containes anchors or if the origin is different we force
      // the hard reloading of the page to avoid serious errors.

      if (!this.running && href !== this.location.href) {
        // We temporary store the future location.
        var location = this.Helpers.getLocation(href); // Set contextual transition values if applicable

        this.Contextual = false;

        if (contextual) {
          this.Contextual = this.Transitions['contextual'][contextual].prototype;
          this.Contextual.name = contextual;
        }

        if (location.origin !== this.location.origin || location.anchor && location.pathname === this.location.pathname) {
          // We redirect when origins are differents or when there is an anchor.
          window.location.href = href;
        } else {
          this.location = location; // Now all our conditions are passed we can update our location and do
          // what we need to do before fetching it.

          this.beforeFetch();
        }
      }
    }
    /**
     * Watch history entry changes.
     */

  }, {
    key: "popState",
    value: function popState() {
      // Save Trigger Element
      this.trigger = 'popstate'; // A contextual transition only effects the transition when a certain link is clicked, not when navigating via browser buttons

      this.Contextual = false; // We temporary store the future location.

      var location = this.Helpers.getLocation(window.location.href); // When users navigate using the browser buttons we check if the locations
      // have no anchors and that our locations are different.

      if (this.location.pathname !== location.pathname || !this.location.anchor && !location.anchor) {
        this.popping = true;
        this.location = location; // If everything is fine we can save our location and do what we need to
        // do before fetching it.

        this.beforeFetch();
      } else {
        // Update Location
        this.location = location;
      }
    }
    /**
     * Update DOM on `click` event.
     */

  }, {
    key: "pushState",
    value: function pushState() {
      if (!this.popping) {
        window.history.pushState(this.location, '', this.location.href);
      }
    }
    /**
     * Fetch the page from URL
     *
     * @return {string} Fetch response
     */

  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(this.location.href, {
                mode: 'same-origin',
                method: 'GET',
                headers: {
                  'X-Requested-With': 'Highway'
                },
                credentials: 'same-origin'
              });

            case 2:
              response = _context.sent;

              if (!(response.status >= 200 && response.status < 300)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", response.text());

            case 5:
              window.location.href = this.location.href;

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    })))
    /**
     * Do some tests before HTTP requests to optimize pipeline.
     */

  }, {
    key: "beforeFetch",
    value: function () {
      var _beforeFetch = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var datas, results;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Push State
                this.pushState(); // We lock the navigation to avoid multiples clicks that could overload the
                // navigation process meaning that if the a navigation is running the user
                // cannot trigger a new one while the previous one is running.

                this.running = true; // We emit an event right before hiding the current view to create a hook
                // for developers that want to do stuffs when an elligible link is clicked.

                this.emit('NAVIGATE_OUT', {
                  from: {
                    page: this.From.properties.page,
                    view: this.From.properties.view
                  },
                  trigger: this.trigger,
                  location: this.location
                }); // Transition Datas

                datas = {
                  trigger: this.trigger,
                  contextual: this.Contextual
                }; // We have to verify our cache in order to save some HTTPRequests. If we
                // don't use any caching system everytime we would come back to a page we
                // already saw we will have to fetch it again and it's pointless.

                if (!this.cache.has(this.location.href)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 7;
                return this.From.hide(datas);

              case 7:
                // Get Properties
                this.properties = this.cache.get(this.location.href);
                _context2.next = 15;
                break;

              case 10:
                _context2.next = 12;
                return Promise.all([this.fetch(), this.From.hide(datas)]);

              case 12:
                results = _context2.sent;
                // Now everything went fine we can extract the properties of the view we
                // successfully fetched and keep going.
                this.properties = this.Helpers.getProperties(results[0]); // We cache our result
                // eslint-disable-next-line

                this.cache.set(this.location.href, this.properties);

              case 15:
                this.afterFetch();

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function beforeFetch() {
        return _beforeFetch.apply(this, arguments);
      }

      return beforeFetch;
    }()
    /**
     * Push page in DOM
     */

  }, {
    key: "afterFetch",
    value: function () {
      var _afterFetch = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var Renderer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.properties.renderer;

              case 2:
                Renderer = _context3.sent;
                this.To = new Renderer(this.properties);
                this.To.add(); // We then emit a now event right before the view is shown to create a hook
                // for developers who want to make stuff before the view is visible.

                this.emit('NAVIGATE_IN', {
                  to: {
                    page: this.To.properties.page,
                    view: this.To.wrap.lastElementChild
                  },
                  trigger: this.trigger,
                  location: this.location
                }); // We wait for the view transition to be over before resetting some variables
                // and reattaching the events to all the new elligible links in our DOM.

                _context3.next = 8;
                return this.To.show({
                  trigger: this.trigger,
                  contextual: this.Contextual
                });

              case 8:
                this.popping = false;
                this.running = false; // Detach Event on Links

                this.detach(this.links); // Get all elligible links.

                this.links = document.querySelectorAll('a:not([target]):not([data-router-disabled])'); // Attach Event on Links

                this.attach(this.links); // Finally we emit a last event to create a hook for developers who want to
                // make stuff when the navigation has ended.

                this.emit('NAVIGATE_END', {
                  to: {
                    page: this.To.properties.page,
                    view: this.To.wrap.lastElementChild
                  },
                  from: {
                    page: this.From.properties.page,
                    view: this.From.properties.view
                  },
                  trigger: this.trigger,
                  location: this.location
                }); // Last but not least we swap the From and To renderers for future navigations.

                this.From = this.To; // Reset Trigger

                this.trigger = null;

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function afterFetch() {
        return _afterFetch.apply(this, arguments);
      }

      return afterFetch;
    }()
  }]);

  return Core;
}(Emitter);

export { Core as default };